import { useTolgeeSSR as useTolgeeSSROriginal } from '@tolgee/react';

import { createTolgeeInstance } from '~/shared/lib/tolgee';

export const useTolgeeSSR = (locale: string) => {
  const tolgeeInstance = createTolgeeInstance();
  return useTolgeeSSROriginal(tolgeeInstance, locale);
};
